<template>
  <div class="question-bank-page">
    <Sidebar @select-chapter="onSelectChapter" />

    <div class="main-area">
      <FilterBar @filter-change="onFilter" />

      <div class="cards">
        <QuestionCard v-for="q in questions" :key="q.questionsId" :q="q" @add-to-paper="onAdd" />
      </div>

      <Pagination :page="page" :pageSize="pageSize" :total="total" @page-change="onPage" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'

import Sidebar from '../components/Sidebar.vue'
import FilterBar from '../components/FilterBar.vue'
import QuestionCard from '../components/QuestionCard.vue'
import Pagination from '../components/Pagination.vue'

const questions = ref([])
const page = ref(1)
const pageSize = ref(10)
const total = ref(0)
const filters = ref({})
const selectedChapter = ref(null)
const paperList = ref([])

async function fetchQuestions() {
  const params = { page: page.value, page_size: pageSize.value, ...filters.value }
  if (selectedChapter.value) params.chapter = selectedChapter.value
  const res = await axios.get('/api/questions', { params })
  questions.value = res.data.questions
  console.log(questions.value);
  total.value = res.data.total
}

onMounted(fetchQuestions)

function onFilter(f) { filters.value = f; page.value = 1; fetchQuestions() }
function onSelectChapter(id) { selectedChapter.value = id; page.value = 1; fetchQuestions() }
function onPage(p) { page.value = p; fetchQuestions() }

function onAdd(q) {
  if (!paperList.value.find(x => x.questionsId === q.questionsId)) {
    paperList.value.push(q)
    alert(`已添加到组卷：ID ${q.questionsId}`)
  }
}
</script>

<style scoped>
.question-bank-page {
  display: flex;
  height: 100vh;
}

.main-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px;
}

.cards {
  flex: 1;
  overflow-y: auto;
}
</style>
